import React from 'react'
import ContentLayout from 'components/layouts/ContentLayout'
import TabsLayout from 'components/layouts/TabsLayout'
import { useSelector } from 'react-redux'
import { SALES_ACTIONS } from 'utils/ui/actions'
import { SALES_TAB_ROUTES } from 'utils/ui/routes'
import { InvoicePaymentAction } from 'components/containers/invoice-payments/types'
import useRbac from 'utils/custom-hooks/useRbac'
interface ConditionalSalesLayoutProps {
  useMinimalObt?: boolean
  SALES_ACTIONS?: SalesAction[]
  SALES_TAB_ROUTES?: SalesTabRoute[]
  INVOICE_PAYMENT_ACTIONS?: InvoicePaymentAction[]
}

export interface SalesAction {
  text: string
  id: string
  onClick: (navigate: (path: string) => void) => void
  icon: JSX.Element
}

export interface SalesTabRoute {
  title: string
  route: string
  matchPath: string
}

const ConditionalSalesLayout: React.FC<ConditionalSalesLayoutProps> = () => {
  const { useMinimalObt } = useSelector((state: any) => state.featureFlags?.variables || {})
  const { getAuthorizedActions, getAuthorizedTabs } = useRbac()
  const authSalesActions = getAuthorizedActions(SALES_ACTIONS)
  const authSalesTabs = getAuthorizedTabs(SALES_TAB_ROUTES)

  return (
    <ContentLayout
      actions={authSalesActions.filter(action => {
        if (useMinimalObt) {
          return action.id === 'create-outbound-ticket-button'
        }
        return true
      })}
      title="Sales"
    >
      <TabsLayout
        tabs={authSalesTabs.filter(r => {
          if (useMinimalObt) {
            return r.route === 'outbound-tickets'
          }
          return true
        })}
      />
    </ContentLayout>
  )
}

export default ConditionalSalesLayout
